import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../data-access/auth.service';

/**
 * Guard for the root route ('') to handle initial redirection efficiently.
 * This avoids unnecessarily loading the auth feature bundle for authenticated users.
 *
 * - If authenticated AND email verified → redirect to dashboard
 * - If authenticated BUT email NOT verified → redirect to verify page
 * - If NOT authenticated → redirect to login page (or landing page if desired)
 */
export const initialRedirectGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isAuthenticated()) {
        if (authService.isEmailVerified()) {
            return router.createUrlTree(['/app/dashboard']);
        } else {
            const user = authService.getStoredUser();
            const email = user?.email ?? '';
            return router.createUrlTree(['/auth/verify'], { queryParams: { email } });
        }
    }

    // If not authenticated, send to login
    return router.createUrlTree(['/auth/login']);
};
